import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import useBreadcrumbs from "use-react-router-breadcrumbs";

import { useRouterHook } from "@/shared/hooks";
import { useRouteCollection } from "@/shared/hooks/useRouteCollection";

import BreadcrumbItem from "./components/BreadcrumbItem/BreadcrumbItem";
import { StyledBreadcrumbs } from "./styled";

interface LocationState {
    title: string;
}

export const Breadcrumbs: FC = () => {
    const { t } = useTranslation();
    const { routeCollection } = useRouteCollection();

    const breadcrumbs = useBreadcrumbs(routeCollection);

    const { getStateOrSearch } = useRouterHook<LocationState>();
    const title = getStateOrSearch("title");
    return (
        <>
            {breadcrumbs.length > 1 && (
                <StyledBreadcrumbs aria-label={t("Common.Breadcrumb")}>
                    {breadcrumbs.map((breadcrumb, index) => (
                        <BreadcrumbItem
                            key={breadcrumb.match.pathname}
                            breadcrumbData={breadcrumb}
                            title={title}
                            isLastItem={index === breadcrumbs.length - 1}
                        ></BreadcrumbItem>
                    ))}
                </StyledBreadcrumbs>
            )}
        </>
    );
};

export default Breadcrumbs;
